module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Aktivität")])]), _vm._v(" "), _c('timeline', {
    attrs: {
      "activities": _vm.activities,
      "big": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79bada66","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activity.vue
// module id = 235
// module chunks = 0